import Vue from "vue";
import Vuex from "vuex";
import Produto from "./modules/produto";
import Marca from "./modules/marca";
import GrupoProduto from "./modules/grupoProduto";
import SecaoProduto from "./modules/secaoProduto";
import Orcamento from "./modules/orcamento";
import FormaPagamento from "./modules/formaPagamento";
import Funcionario from "./modules/funcionario";
import Perfil from "./modules/perfil";
import Permissao from "./modules/permissao";
import Empresa from "./modules/empresa";
import Venda from "./modules/venda";
import Cargo from "./modules/cargo";
import Contato from "./modules/contato";
import Estoque from "./modules/estoque";
import TransferenciaEstoque from "./modules/estoque/transferencia";
import Banco from "./modules/banco";
import ContaPagar from "./modules/financeiro/contaPagar";
import ContaReceber from "./modules/financeiro/contaReceber";
import GrupoFinanceiro from "./modules/financeiro/grupo";
import PortadorFinanceiro from "./modules/financeiro/portador";
import LancamentoBancario from "./modules/financeiro/lancamentoBancario";
import LancamentoCaixa from "./modules/caixa/lancamento";
import NFe from "./modules/nfe/nfe";
import TrocaVenda from "./modules/venda/troca";
import Contrato from "./modules/contrato";
import GrupoPermissao from "./modules/permissao/grupo-permissao";
import PedidoCompra from "./modules/pedidoCompra";
import UnidadeMedida from "./modules/produto/unidadeMedida";
import Fabricante from "./modules/fabricante";
import BandeiraCartao from "./modules/formaPagamento/bandeiraCartao";
import EntradaMercadoria from "./modules/entradaMercadoria";
import Estado from "./modules/estado";
import Cidade from "./modules/estado/cidade";
import RelatorioVenda from "./modules/relatorio/venda";
import Log from "./modules/log";
import OrdensDeServico from "./modules/ordemServico";
import ModeloTanque from "./modules/modeloTanque";
import AtividadeOs from "./modules/ordemServico/atividadesOS"
import NCM from "./modules/ncm"
import PosVenda from "./modules/crm/posVenda"
import AtividadePosVenda from "./modules/crm/posVenda/atividade"
import CrmProposta from "./modules/crm/proposta"
import AtividadeCrmProposta from "./modules/crm/proposta/atividade"
import Notificacao from "./modules/notificacao"
import PesquisaSatisfacao from "./modules/crm/pesquisaSatisfacao"
import GradeProduto from "./modules/gradeProduto"
import Etiqueta from "./modules/etiqueta"
import { router } from "@/router";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    modalConfirmacao: {
      aberto: false,
      icon: "",
      cor: "",
      mensagem: "",
      action: "",
      value: "",
    },
    vueLoad: false,
    drawer: true,
    overlay: false,
    user: sessionStorage.getItem("user") ? JSON.parse(sessionStorage.getItem("user")) : null,
    token: sessionStorage.getItem("token") ? sessionStorage.getItem("token") : null,
    modalPrint: {
      link: "",
      show: false,
    },
    itensVenda: [],
    empresaSelecionadaId: parseInt(sessionStorage.getItem("empresaId")) ? parseInt(sessionStorage.getItem("empresaId")) : null,
    empresaSelecionada: sessionStorage.getItem("empresa") ? JSON.parse(sessionStorage.getItem("empresa")) : null,
    snackbar: {
      text: "teste",
      color: "",
      status: false,
      timeout: 6000,
    },
    alert: {
      typeAlert: "success",
      status: false,
      errors: [],
    },
  },
  mutations: {
    setVueLoad(state, status) {
      state.vueLoad = status;
    },
    ativaModalConfirmacao(state, payload) {
      state.modalConfirmacao = {};
      state.modalConfirmacao = payload;
    },
    desativaModalConfirmacao(state) {
      state.modalConfirmacao = {
        aberto: false,
        icon: "",
        cor: "",
        mensagem: "",
        action: "",
        action_value: "",
      };
    },
    setOverlay(state, n) {
      state.overlay = n;
    },
    setUser(state, n) {
      state.user = n;
    },
    addItemVenda(state, data) {
      state.itensVenda.push(data);
    },

    removeItemVenda(state, item) {
      let indice = state.itensVenda.indexOf(item);
      state.itensVenda.splice(indice, 1);
    },
    snackbarError(state, text) {
      state.snackbar.status = true;
      state.snackbar.text = text;
      state.snackbar.color = "error";
    },

    snackbarWarning(state, text) {
      state.snackbar.status = true;
      state.snackbar.text = text;
      state.snackbar.color = "orange darken-2";
    },

    snackbarSuccess(state, text) {
      state.snackbar.status = true;
      state.snackbar.text = text;
      state.snackbar.color = "success";
    },
    snackbarInfo(state, text) {
      state.snackbar.status = true;
      state.snackbar.text = text;
      state.snackbar.color = "info";
    },
    snackbarDisabled(state, status) {
      state.snackbar.status = false;
      state.snackbar.text = "";
      state.snackbar.color = "";
    },
    alertError(state, errors) {
      state.alert.typeAlert = "error";
      state.alert.status = true;
      state.alert.errors = errors;
      // setTimeout(() => {
      //   state.alert.status = false;
      // }, 15000);
    },
    alertSuccess(state, messages) {
      state.alert.typeAlert = "success";
      state.alert.status = true;
      state.alert.errors = messages;
    },
    unsetAlert(state) {
      state.alert.status = false;
    },
    setEmpresaSelecionadaId(state, id) {
      state.empresaSelecionadaId = id;
    },
    setEmpresaSelecionada(state, data) {
      state.EmpresaSelecionada = data;
    },
    setModalPrint(state, link) {
      state.modalPrint.show = false;
      state.modalPrint.show = true;
      state.modalPrint.link = link;
    },
    setDrawer(state, status) {
      state.drawer = status;
    },
  },
  actions: {
    logout: ({ commit }) => {
      sessionStorage.clear();
      router.push({ name: "login" });
      commit("setUser", null);
      location.reload();
    },
    setEmpresaSelecionadaId: ({ commit }, id) => {
      commit("setEmpresaSelecionadaId", id);
      sessionStorage.setItem("empresaId", id);
      location.reload();
    },
    setEmpresaSelecionada: ({ commit, dispatch }, data) => {
      dispatch("setEmpresaSelecionadaId", data.id);
      sessionStorage.setItem("empresa", JSON.stringify(data));
    },
    setDrawer: ({ commit }, status) => {
      commit("setDrawer", status);
    },
    ativaModalConfirmacao: ({ commit }, payload) => {
      commit("ativaModalConfirmacao", {
        aberto: true,
        icone: "warning",
        cor: payload.cor ? payload.cor : "yellow darken-3",
        action: payload.action,
        action_value: payload.action_value,
        mensagem: payload.mensagem,
      });
    },
    desativaModalConfirmacao: ({ commit }) => {
      commit("desativaModalConfirmacao");
    },
    unsetAlert(state) {
      state.commit("unsetAlert");
    },
  },
  getters: {
    getUser: (state) => state.user,
    getToken: (state) => state.token,
    getSnackbar: (state) => state.snackbar,
    getOverlay: (state) => state.overlay,
    getAlert: (state) => state.alert,
    getItensVenda: (state) => state.itensVenda,
    getEmpresaSelecionadaId: (state) => state.empresaSelecionadaId,
    getModalPrint: (state) => state.modalPrint,
    getEmpresaSelecionada: (state) => state.empresaSelecionada,
    getDrawer: (state) => state.drawer,
    getModalConfirmacao: (state) => state.modalConfirmacao,
  },
  modules: {
    produto: {
      state: { ...Produto.state },
      getters: { ...Produto.getters },
      mutations: { ...Produto.mutations },
      actions: { ...Produto.actions },
    },
    marca: {
      state: { ...Marca.state },
      getters: { ...Marca.getters },
      mutations: { ...Marca.mutations },
      actions: { ...Marca.actions },
    },
    grupoProduto: {
      state: { ...GrupoProduto.state },
      getters: { ...GrupoProduto.getters },
      mutations: { ...GrupoProduto.mutations },
      actions: { ...GrupoProduto.actions },
    },
    secaoProduto: {
      state: { ...SecaoProduto.state },
      getters: { ...SecaoProduto.getters },
      mutations: { ...SecaoProduto.mutations },
      actions: { ...SecaoProduto.actions },
    },
    Orcamento: {
      state: { ...Orcamento.state },
      getters: { ...Orcamento.getters },
      mutations: { ...Orcamento.mutations },
      actions: { ...Orcamento.actions },
    },
    FormaPagamento: {
      state: { ...FormaPagamento.state },
      getters: { ...FormaPagamento.getters },
      mutations: { ...FormaPagamento.mutations },
      actions: { ...FormaPagamento.actions },
    },
    Funcionario: {
      state: { ...Funcionario.state },
      getters: { ...Funcionario.getters },
      mutations: { ...Funcionario.mutations },
      actions: { ...Funcionario.actions },
    },
    Perfil: {
      state: { ...Perfil.state },
      getters: { ...Perfil.getters },
      mutations: { ...Perfil.mutations },
      actions: { ...Perfil.actions },
    },
    Permissao: {
      state: { ...Permissao.state },
      getters: { ...Permissao.getters },
      mutations: { ...Permissao.mutations },
      actions: { ...Permissao.actions },
    },
    Empresa: {
      state: { ...Empresa.state },
      getters: { ...Empresa.getters },
      mutations: { ...Empresa.mutations },
      actions: { ...Empresa.actions },
    },
    Venda: {
      state: { ...Venda.state },
      getters: { ...Venda.getters },
      mutations: { ...Venda.mutations },
      actions: { ...Venda.actions },
    },
    Cargo: {
      state: { ...Cargo.state },
      getters: { ...Cargo.getters },
      mutations: { ...Cargo.mutations },
      actions: { ...Cargo.actions },
    },
    Contato: {
      state: { ...Contato.state },
      getters: { ...Contato.getters },
      mutations: { ...Contato.mutations },
      actions: { ...Contato.actions },
    },
    Estoque: {
      state: { ...Estoque.state },
      getters: { ...Estoque.getters },
      mutations: { ...Estoque.mutations },
      actions: { ...Estoque.actions },
    },
    TransferenciaEstoque: {
      state: { ...TransferenciaEstoque.state },
      getters: { ...TransferenciaEstoque.getters },
      mutations: { ...TransferenciaEstoque.mutations },
      actions: { ...TransferenciaEstoque.actions },
    },
    Banco: {
      state: { ...Banco.state },
      getters: { ...Banco.getters },
      mutations: { ...Banco.mutations },
      actions: { ...Banco.actions },
    },
    ContaPagar: {
      state: { ...ContaPagar.state },
      getters: { ...ContaPagar.getters },
      mutations: { ...ContaPagar.mutations },
      actions: { ...ContaPagar.actions },
    },
    ContaReceber: {
      state: { ...ContaReceber.state },
      getters: { ...ContaReceber.getters },
      mutations: { ...ContaReceber.mutations },
      actions: { ...ContaReceber.actions },
    },
    GrupoFinanceiro: {
      state: { ...GrupoFinanceiro.state },
      getters: { ...GrupoFinanceiro.getters },
      mutations: { ...GrupoFinanceiro.mutations },
      actions: { ...GrupoFinanceiro.actions },
    },
    PortadorFinanceiro: {
      state: { ...PortadorFinanceiro.state },
      getters: { ...PortadorFinanceiro.getters },
      mutations: { ...PortadorFinanceiro.mutations },
      actions: { ...PortadorFinanceiro.actions },
    },
    LancamentoBancario: {
      state: { ...LancamentoBancario.state },
      getters: { ...LancamentoBancario.getters },
      mutations: { ...LancamentoBancario.mutations },
      actions: { ...LancamentoBancario.actions },
    },
    LancamentoCaixa: {
      state: { ...LancamentoCaixa.state },
      getters: { ...LancamentoCaixa.getters },
      mutations: { ...LancamentoCaixa.mutations },
      actions: { ...LancamentoCaixa.actions },
    },
    NFe: {
      state: { ...NFe.state },
      getters: { ...NFe.getters },
      mutations: { ...NFe.mutations },
      actions: { ...NFe.actions },
    },
    TrocaVenda: {
      state: { ...TrocaVenda.state },
      getters: { ...TrocaVenda.getters },
      mutations: { ...TrocaVenda.mutations },
      actions: { ...TrocaVenda.actions },
    },
    Contrato: {
      state: { ...Contrato.state },
      getters: { ...Contrato.getters },
      mutations: { ...Contrato.mutations },
      actions: { ...Contrato.actions },
    },
    GrupoPermissao: {
      state: { ...GrupoPermissao.state },
      getters: { ...GrupoPermissao.getters },
      mutations: { ...GrupoPermissao.mutations },
      actions: { ...GrupoPermissao.actions },
    },
    PedidoCompra: {
      state: { ...PedidoCompra.state },
      getters: { ...PedidoCompra.getters },
      mutations: { ...PedidoCompra.mutations },
      actions: { ...PedidoCompra.actions },
    },
    UnidadeMedida: {
      state: { ...UnidadeMedida.state },
      getters: { ...UnidadeMedida.getters },
      mutations: { ...UnidadeMedida.mutations },
      actions: { ...UnidadeMedida.actions },
    },
    Fabricante: {
      state: { ...Fabricante.state },
      getters: { ...Fabricante.getters },
      mutations: { ...Fabricante.mutations },
      actions: { ...Fabricante.actions },
    },
    BandeiraCartao: {
      state: { ...BandeiraCartao.state },
      getters: { ...BandeiraCartao.getters },
      mutations: { ...BandeiraCartao.mutations },
      actions: { ...BandeiraCartao.actions },
    },
    EntradaMercadoria: {
      state: { ...EntradaMercadoria.state },
      getters: { ...EntradaMercadoria.getters },
      mutations: { ...EntradaMercadoria.mutations },
      actions: { ...EntradaMercadoria.actions },
    },

    Cidade: {
      state: { ...Cidade.state },
      getters: { ...Cidade.getters },
      mutations: { ...Cidade.mutations },
      actions: { ...Cidade.actions },
    },
    Estado: {
      state: { ...Estado.state },
      getters: { ...Estado.getters },
      mutations: { ...Estado.mutations },
      actions: { ...Estado.actions },
    },
    RelatorioVenda: {
      state: { ...RelatorioVenda.state },
      getters: { ...RelatorioVenda.getters },
      mutations: { ...RelatorioVenda.mutations },
      actions: { ...RelatorioVenda.actions },
    },
    Logs: {
      state: { ...Log.state },
      getters: { ...Log.getters },
      mutations: { ...Log.mutations },
      actions: { ...Log.actions },
    },
    Ordens: {
      state: { ...OrdensDeServico.state },
      getters: { ...OrdensDeServico.getters },
      mutations: { ...OrdensDeServico.mutations },
      actions: { ...OrdensDeServico.actions },
    },
    ModeloTanque: {
      state: { ...ModeloTanque.state },
      getters: { ...ModeloTanque.getters },
      mutations: { ...ModeloTanque.mutations },
      actions: { ...ModeloTanque.actions },
    },
    AtividadeOs: {
      state: { ...AtividadeOs.state },
      getters: { ...AtividadeOs.getters },
      mutations: { ...AtividadeOs.mutations },
      actions: { ...AtividadeOs.actions },
    },
    NCM: {
      state: { ...NCM.state },
      getters: { ...NCM.getters },
      mutations: { ...NCM.mutations },
      actions: { ...NCM.actions },
    },
    PosVenda: {
      state: { ...PosVenda.state },
      getters: { ...PosVenda.getters },
      mutations: { ...PosVenda.mutations },
      actions: { ...PosVenda.actions },
    },
    AtividadePosVenda: {
      state: { ...AtividadePosVenda.state },
      getters: { ...AtividadePosVenda.getters },
      mutations: { ...AtividadePosVenda.mutations },
      actions: { ...AtividadePosVenda.actions },
    },
    CrmProposta: {
      state: { ...CrmProposta.state },
      getters: { ...CrmProposta.getters },
      mutations: { ...CrmProposta.mutations },
      actions: { ...CrmProposta.actions },
    },
    AtividadeCrmProposta: {
      state: { ...AtividadeCrmProposta.state },
      getters: { ...AtividadeCrmProposta.getters },
      mutations: { ...AtividadeCrmProposta.mutations },
      actions: { ...AtividadeCrmProposta.actions },
    },
    Notificacao: {
      state: { ...Notificacao.state },
      getters: { ...Notificacao.getters },
      mutations: { ...Notificacao.mutations },
      actions: { ...Notificacao.actions },
    },
    PesquisaSatisfacao: {
      state: { ...PesquisaSatisfacao.state },
      getters: { ...PesquisaSatisfacao.getters },
      mutations: { ...PesquisaSatisfacao.mutations },
      actions: { ...PesquisaSatisfacao.actions },
    },
    GradeProduto: {
      state: { ...GradeProduto.state },
      getters: { ...GradeProduto.getters },
      mutations: { ...GradeProduto.mutations },
      actions: { ...GradeProduto.actions },
    },
    Etiqueta: {
      state: { ...Etiqueta.state },
      getters: { ...Etiqueta.getters },
      mutations: { ...Etiqueta.mutations },
      actions: { ...Etiqueta.actions },
    },
  },
});
